export enum SimulatorScreenEnum {
  'WHATSAPP' = 'whatsapp',
  'ZONOMONEY' = 'zono_money',
}
